import cn from '@/lib/utils/cn';

type Props = {
  amount: Maybe<number>;
};

export default function AmountCircle({ amount }: Props) {
  return (
    <span
      className={cn(
        'flex size-5.5 shrink-0 items-center justify-center rounded-full text-xs',
        'text-muted-foreground bg-neutral-200 dark:bg-neutral-800',
      )}
    >
      {amount}
    </span>
  );
}
